import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { BrandLogo } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import AdminReports from "@/pages/admin/AdminReports";

/**
 * Wrapper para que el staff acceda al mismo componente de reportes,
 * con header propio (no comparte AdminLayout).
 * Backend fuerza el filtro a su propio staff_id por el rol.
 */
export default function StaffReports() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white sticky top-0 z-10">
        <div className="mx-auto max-w-6xl px-6 py-4 flex items-center justify-between">
          <Link to="/staff/me"><BrandLogo /></Link>
          <div className="flex items-center gap-3">
            <span className="text-sm text-slate-600 hidden sm:inline">{user?.name}</span>
            <Link to="/staff/me"><Button variant="outline">Mi agenda</Button></Link>
            <Button variant="outline" onClick={() => logout().then(() => navigate("/"))}>Cerrar sesión</Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-12">
        <AdminReports />
      </main>
    </div>
  );
}
